import React, { createContext, useContext } from 'react';
import { Heading } from 'core/components';

/**
 * Set when Kentik AI settings are embedded in a host (e.g. the AI Advisor) whose own header shows the panel title.
 */
export const EmbeddedSettingsContext = createContext(false);

/**
 * A settings panel's own title. Hidden when embedded, so the title isn't shown twice.
 */
const SettingsPanelHeading = (props) => {
  const isEmbedded = useContext(EmbeddedSettingsContext);
  return isEmbedded ? null : <Heading {...props} />;
};

export default SettingsPanelHeading;
